import { action, computed, makeAutoObservable } from "mobx";

const METADATA_KEY = "application_metadata";

class ApplicationStore {
    private _metadata: { [key: string]: string } = {};

    constructor() {
        makeAutoObservable(this);

        if (typeof window !== "undefined") {
            this.onLoad();
        }
    }

    @action
    private onLoad() {
        this.readMetadata();
    }

    @action
    setMetadataField(key: string, value: string) {
        this._metadata[key] = value;
        this.setMetadata();
    }

    @computed
    get metadata() {
        return this._metadata ?? {};
    }

    @action
    clearMetadata() {
        // clear metadata from local storage
        localStorage.removeItem(METADATA_KEY);
    }

    private readMetadata() {
        // read metadata from local storage
        if (localStorage.getItem(METADATA_KEY)) {
            this._metadata =
                JSON.parse(localStorage.getItem(METADATA_KEY) ?? "{}") ?? {};
        }
    }

    private setMetadata() {
        // write metadata to local storage
        localStorage.setItem(METADATA_KEY, JSON.stringify(this._metadata));
    }
}

export default new ApplicationStore();
